import { types } from 'mobx-state-tree';

export const ApplicationFormSettingsModel = types
  .model('ApplicationFormSettings', {
    phone: types.maybeNull(types.union(types.string, types.boolean)),
    professional_experience: types.maybeNull(types.union(types.string, types.boolean)),
    cover_letter: types.maybeNull(types.union(types.string, types.boolean)),
    country: types.maybeNull(types.union(types.string, types.boolean)),
    education: types.maybeNull(types.union(types.string, types.boolean)),
    languages: types.maybeNull(types.union(types.string, types.boolean)),
    custom_questions: types.maybeNull(types.frozen()),
    external_url: types.maybeNull(types.string)
  })
  .views(self => ({
    get formatted() {
      return {
        ...self,
        custom_questions: Object.values(self.custom_questions || {})
      };
    }
  }));
